import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import { tileDesktopLayout } from './constants'

const Container = styled.div`
  grid-area: image;
  display: grid;
  grid-template: 1fr / 1fr;
  width: ${rem(64)};
  height: ${rem(64)};

  ${tileDesktopLayout} {
    width: ${rem(190)};
    height: 100%;
  }

  position: relative;
  > picture {
    position: absolute;
    inset: 0;
  }
`

const LabelsContainer = styled(LabelGroup)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: none;
  padding: ${rem(8)};

  ${tileDesktopLayout} {
    display: unset;
    z-index: 2;
  }
`

interface Props {
  imageElement: ReactElement
  label?: ReactElement
}

function CartReviewTileImage({ imageElement, label }: Props) {
  return (
    <Container>
      {imageElement}
      <LabelsContainer>
        {label}
      </LabelsContainer>
    </Container>
  )
}

export default CartReviewTileImage
